import {RouterProvider} from 'react-router-dom'
import  { router } from "./routes/AppRoutes";

import "./styles/index.css"
import 'animate.css';

function App() {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
